export default __webpack_public_path__ + "6a2ae2f5cde9b92c9db594f8e1ee5bec.png";